import { FunctionKeys } from "@/types/util/type-util"

interface ILogger {
    log(message: string, devOnly?: boolean, ...optionalParams: any[]): void
    debug(message: string, devOnly?: boolean, ...optionalParams: any[]): void
    info(message: string, devOnly?: boolean, ...optionalParams: any[]): void
    warn(message: string, devOnly?: boolean, ...optionalParams: any[]): void
    error(message: string, devOnly?: boolean, ...optionalParams: any[]): void
}

export type LoggerMethods = FunctionKeys<ILogger>

export enum LogLevel {
    Trace = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4
}

export interface LoggerConfig {
    logLevel?: LogLevel
    depthLimit?: number
    prettyPrintOutput?: boolean
    console?: Console
}

export default ILogger
